import SystemMessagesApi from '../api/SystemMessagesApi';
import SystemMessageConstants from '../constants/SystemMessageConstants';

function fetchSystemMessages(priority) {
  return {
    types: [SystemMessageConstants.SYSTEM_MESSAGES_REQUEST,
      SystemMessageConstants.SYSTEM_MESSAGES_SUCCESS,
      SystemMessageConstants.SYSTEM_MESSAGES_ERROR],
    apiRequest: (state, client) => SystemMessagesApi.fetchSystemMessages(state, client, priority)
  };
}

function toggleMessage(id) {
  return {
    type: SystemMessageConstants.TOGGLE_SYSTEM_MESSAGE,
    id
  };
}


export default {
  fetchSystemMessages,
  toggleMessage
};



// WEBPACK FOOTER //
// ./app/actions/SystemMessageActions.js